module.exports = __webpack_public_path__ + "static/media/banner_mobil_5.e73d619e.png";